"use client";

import { env } from "@/env.mjs";
import { organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authAdminClient = createAuthClient({
	baseURL: env.NEXT_PUBLIC_ROOT_URL,
	plugins: [organizationClient()],
});

export const authStoreClient = (baseURL: string) => createAuthClient({ baseURL, plugins: [] });
